export default "__VITE_ASSET__CpF6ZVGk__"